// デバッグオプション集約モジュール
//
// 優先順位 (各キーごとに独立評価):
//   1. URL クエリ引数  (例: ?debug=true&debug_eval_log=false)  ← 自動テストで最優先
//   2. localStorage    (UI トグルで永続化)
//   3. ハードコードのデフォルト値
//
// 使い方:
//   window.debugOpts.enabled         → ?debug=true か
//   window.debugOpts.evalLog         → eval 計算ログ
//   window.debugOpts.payloadLog      → 送信 payload ログ
//   window.debugOpts.firebaseWrite   → debug でも Firebase へ実書き込み (デフォルト OFF)
//   window.debugOpts.skipWelcome     → ウェルカムダイアログを自動 skip
//   window.debugOpts.skipAnsIdNotice → 回答番号事前周知を自動 skip
//
//   window.debugOpts.set('evalLog', false)   → トグル + localStorage に永続化
//   window.debugOpts.urlOverridden('evalLog')→ URL 引数で固定されているか (UI で disabled 表示用)
;(function () {
  const LS_PREFIX = 'q4cl_debug_';
  const params = new URLSearchParams(window.location.search);

  // boolean っぽい文字列の解釈 (true/1/on → true、 false/0/off → false、 それ以外 → null)
  function parseBool(v) {
    if (v == null) return null;
    const s = String(v).toLowerCase();
    if (s === 'true' || s === '1' || s === 'on' || s === 'yes') return true;
    if (s === 'false' || s === '0' || s === 'off' || s === 'no') return false;
    return null;
  }

  // 各オプションの定義 (key, urlParamName, default)
  const DEFS = [
    { key: 'evalLog',         param: 'debug_eval_log',          default: true  },
    { key: 'payloadLog',      param: 'debug_payload_log',       default: true  },
    { key: 'firebaseWrite',   param: 'debug_firebase_write',    default: false },
    { key: 'skipWelcome',     param: 'debug_skip_welcome',      default: false },
    { key: 'skipAnsIdNotice', param: 'debug_skip_ansid_notice', default: false }
  ];

  const urlValues = {};  // URL 引数で固定された値 (UI からは変更不可)
  const initial = {};

  for (const d of DEFS) {
    const urlVal = parseBool(params.get(d.param));
    if (urlVal !== null) {
      urlValues[d.key] = urlVal;
      initial[d.key] = urlVal;
      continue;
    }
    const lsRaw = localStorage.getItem(LS_PREFIX + d.key);
    const lsVal = parseBool(lsRaw);
    initial[d.key] = lsVal !== null ? lsVal : d.default;
  }

  const state = Vue.reactive({
    enabled: parseBool(params.get('debug')) === true,
    ...initial
  });

  function set(key, value) {
    if (urlValues[key] !== undefined) {
      console.warn('[debugOpts] "' + key + '" は URL 引数で固定されているため変更できません');
      return;
    }
    const v = !!value;
    state[key] = v;
    try { localStorage.setItem(LS_PREFIX + key, v ? 'true' : 'false'); } catch (e) { /* ignore */ }
  }

  function urlOverridden(key) {
    return urlValues[key] !== undefined;
  }

  // 「定義一覧」 を UI が読めるよう公開
  state._defs = DEFS;
  state.set = set;
  state.urlOverridden = urlOverridden;

  window.debugOpts = state;
})();
